// Different simulation cases
const simulationMenu = props => ({
  key: 'simulation',
  caption: 'Simulation Use Cases',
  subMenuItems: [
    {
      key: 'simulation-vehicle-capable',
      caption: 'Vehical Capability',
      onClick: () => props.vehicleCapableError(),
    },
    {
      key: 'simulation-subscription-enrolled',
      caption: 'Subscription Enrolled',
      onClick: () => props.subscriptionError(),
    },
    {
      key: 'simulation-authValue',
      caption: 'QRValue',
      onClick: () => props.getQrAuthValue(),
    },
    {
      key: 'simulation-authentication',
      caption: 'Scan QRCode',
      onClick: () => {
        props.authSuccess();
      },
    },
    {
      key: 'simulation-authentication-update',
      caption: 'Update',
      onClick: () => {
        props.updateAuthStatus();
      },
    },
  ],
});

export default simulationMenu;
